import { useEffect, useRef, useState } from "react";
import LoginService from "./LoginService";
import { useNavigate } from "react-router-dom";
import EmpDetailsForm from "../NOC/EmpDetailsForm";
import ModalComp from "../common/ModalComp";
import NocForm from "../NOC/NocForm";
import "../style/style.css";
import styled from "styled-components";
import { Form } from "react-bootstrap";
import { BiRefresh } from 'react-icons/bi';
import { FaEye, FaEyeSlash } from 'react-icons/fa';


const LoginPage = () => {
  const navigate = useNavigate();
  // const [formValues1,setFormValues1] = useState({});
  const [passwordFlg, setPasswordFlg] = useState(false);
  const [captchaFlg, setCaptchaFlg] = useState(false);
  const [empBasicShow, setEmpBasicShow] = useState(false);
  const empBasicShowClose = () => { setEmpBasicShow(false); getCaptcha() }
  const [nocFormModalShow, setNocFormModalShow] = useState(false);
  const nocFormModalShowClose = () => { setNocFormModalShow(false); getCaptcha(); }
  const [passportNo, setPassportNo] = useState(0);
  const [capId, setCapId] = useState(0);
  const [appStatus, setAppStatus] = useState('D');
  const [showNewPassword, setShowNewPassword] = useState(false);
  const captchaRef = useRef();
  const captchaIdRef = useRef();
  const CaptchaImage = styled.img`
    width: 150px;
    height: 50px;
`

  useEffect(() => {
    sessionStorage.clear();
    getCaptcha();
  }, []);

  const getCaptcha = async () => {
    // Get Captcha        

    try {

      const captchaId = 0;
      const captcha = await LoginService.getCaptcha(captchaId);

      captchaRef.current.src = 'data:image/png;base64,' + captcha.captchaData;

      captchaIdRef.current.value = captcha.captchaId;


    } catch (error) {
      console.error(error);
    }
  }
  const getLogin = () => {

    var userName = document.getElementById('userName').value;
    var password = document.getElementById('passwordId').value;

    if (!userName || !password) {
      alert("Please provide username and password");
      return;
    }
    const form = document.getElementById('loginForm');
    const data = new FormData(form);
    const values = Object.fromEntries(data.entries());
    LoginService.getLogin(values).then((r) => {
      if (r.token != null) {
        sessionStorage.setItem("user", r.id);
        sessionStorage.setItem("userRole", r.userRole);
        sessionStorage.setItem("userFullName", r.userFullName);
        sessionStorage.setItem("userRoleName", r.userRoleName);
        sessionStorage.setItem("token", r.token);

        sessionStorage.setItem("userDetails", JSON.stringify(r));
        navigate("/pending");
      }
      else {
        if (r.statusCode == 2) {
          alert("Captcha not valid, Please enter valid captcha");
          setCaptchaFlg(true);
        }
        else {
          setPasswordFlg(true);
        }
        setTimeout(() => {
          getCaptcha();
        }, 1000);

      }
    })
      .catch((error) => {
        if (error.response && error.response.status === 500 && error.response.data.message === "Invalid Credentials") {
          alert("Invalid username or password. Please try again.");
          form.reset();
          getCaptcha();
        } else {
          alert("An unexpected error occurred. Please try again.");
        }
      });
  }
  const openEmpBasic = () => {
    setEmpBasicShow(true)
  }
  const callBack = (appId, status) => {
    if (status == 'E') {
      alert("OTP is not valid");
      return;
    }
    getCaptcha();
    setAppStatus(status);
    setPassportNo(appId);
    setEmpBasicShow(false);
    setNocFormModalShow(true);
  }
  const callBackMain = () => {
    setNocFormModalShow(false);
    getCaptcha();
  }

  const togglePasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };

  return (

    <div className="form-login-body">
      <Form id='loginForm' >
        <div className="container-fluid">
          <div className="top-menu">
            <section>
              <div className="container-fluid">
                <div className="d-flex flex-wrap">
                  <div className="main-content">
                    <div className="col-md-12 col-xs-12 col-sm-12">
                      <div className="container-fluid">
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', margin: '1em auto' }}>
                          <h2 className="text-center my-3" style={{ color: '#d0a779', fontWeight: '700', fontSize: '30px' }}>HMFW Department Application</h2>
                          <button type="button" onClick={openEmpBasic} className="btn mx-1 main-button-two mt-2 " target="_blank">Click here to apply for NOC for Abroad Travel</button>
                          <input type="hidden" id='captchaId' name='captchaId' ref={captchaIdRef} />
                          <div>
                            <p class="mb-2 px-5" style={{ fontSize: '14px', marginLeft: '2px', marginRight: '26px', color: '#667BC6' }}>Applicants are advised to collect the following documents from the concerned DDO office in advance for filling out the online NOC application:</p>
                            <ul class="mx-5" style={{ fontSize: '14px', paddingLeft: '34px', color: '#667BC6' }} >
                              <li style={{ listStyleType: 'circle' }}>Certificate of Head of Department/Institution</li>
                              <li style={{ listStyleType: 'circle' }}>No Charge Pending</li>
                              <li style={{ listStyleType: 'circle' }}>Service Satisfactory Certificate</li>
                              <li style={{ listStyleType: 'circle' }}>No Dues Certificate</li>
                              <li style={{ listStyleType: 'circle' }}>Copy of Service Regularization And Probation Declaration</li>
                              <li style={{ listStyleType: 'circle' }}>DDO Covering Letter</li>
                              <li style={{ listStyleType: 'circle' }}>Certificate by The First Surety</li>
                              <li style={{ listStyleType: 'circle' }}>Latest Payslip of the First Surety</li>
                              <li style={{ listStyleType: 'circle' }}>Certificate by The Second Surety</li>
                              <li style={{ listStyleType: 'circle' }}>Latest Payslip of the Second Surety</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="main-content">
                    <div className="col-md-4 text-center company__info">
                      <span className="company__logo">
                        <img src="/assets/img/logo.jpg" alt="Logo" />
                      </span>
                    </div>
                    <div className="col-md-8 col-xs-12 col-sm-12 login_form">
                      <div className="container-fluid">
                        <div className="row">
                          <h2 className="text-center my-3">HMFW Department Login</h2>
                          {/* {passwordFlg ? <h6>Username Or Password Not Valid</h6> : ""} */}
                          {/* {captchaFlg ? <h6>Captcha Not Valid</h6> : ""} */}
                        </div>
                        <div className="row">
                          <div>
                            <div className="mb-3">
                              {/* <label htmlFor="floatingInput" className="float-label">Enter Username</label> */}
                              <input type="text" placeholder="Enter Username" name="userName" className="form-control" id="userName" />
                            </div>
                          </div>
                          <div>
                            <div className="mb-3">
                              {/* <label htmlFor="floatingInput" className="float-label">Enter password</label> */}
                              <input type={showNewPassword ? "text" : "password"} placeholder="Enter Password" name="password" className="form-control" id="passwordId" />
                              <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={togglePasswordVisibility}
                                style={{
                                  border: 'none',
                                  background: 'transparent',
                                  margin: '0',
                                  boxShadow: 'none',
                                  position: 'relative',
                                  top: '-58px',
                                  left: '88%'
                                }}
                              >
                                {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                              </button>
                            </div>
                          </div>
                          <div>
                            <div className="mb-3">
                              <CaptchaImage src='' id='catpchaImg' ref={captchaRef} />
                              <span onClick={getCaptcha} style={{ cursor: 'pointer' }}>
                                <BiRefresh size={30} />
                              </span>
                            </div>
                          </div>
                          <div>
                            <div className="mb-3">
                              {/* <label htmlFor="floatingInput" className="float-label">Enter captacha</label> */}
                              <input type="text" name="captcha" placeholder="Enter Captcha" className="form-control" onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  e.preventDefault();
                                  getLogin();
                                }
                              }} />

                            </div>
                          </div>

                          <div className="d-flex align-items-baseline justify-content-center">
                            <button type="button" onClick={getLogin} className="btn mx-1 main-button" >Sign In</button>
                            {/* <p className="mb-0"><a href="#">Forgot Password</a></p> */}
                          </div>
                          {/* </form> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="footer" style={{ padding: '4px 0', textAlign: 'center', backgroundColor: '#479d6c', color: '#fff', fontSize: '16px', fontWeight: 'bold' }}>
                <div className="container-fluid">
                  <p style={{ marginBottom: 0 }}>© Content Owned by Health Medical and Family Welfare Department Government of Telangana</p>
                </div>
              </div>
            </section>


          </div>

        </div >
      </Form >
      <ModalComp
        size={"lg"}
        show={empBasicShow}
        handleClose={empBasicShowClose}
        modalTitle={"Employee Basic Information"}
        modalBody={<EmpDetailsForm callBack={callBack}></EmpDetailsForm>}
      />
      <ModalComp
        size={"lg"}
        show={nocFormModalShow}
        handleClose={nocFormModalShowClose}
        modalTitle={"Proforma particulars to be furnished for issuing NOC"}
        modalBody={appStatus == 'S' ? <span style={{ "color": "red" }}>Application is in under process</span> : <NocForm passportNo={passportNo} callBack={callBackMain}></NocForm>}
      />
    </div >
  );
}

export default LoginPage;